import React, { createContext, useContext, useState } from 'react';

type Language = 'es' | 'en';

// Define a type for all possible translation keys
type TranslationKey = 
  | 'nav.home' 
  | 'nav.about'
  | 'nav.industries'
  | 'nav.services'
  | 'nav.clients'
  | 'nav.contact'
  | 'banner.title'
  | 'banner.title2'
  | 'banner.subtitle'
  | 'banner.schedule'
  | 'home.consulting.title'
  | 'home.consulting.text'
  | 'home.development.title'
  | 'home.development.text'
  | 'home.training.title'
  | 'home.training.text'
  | 'services.title'
  | 'services.consulting.title'
  | 'services.ai.title'
  | 'services.development.title'
  | 'services.training.title'
  | 'services.consulting.project.title'
  | 'services.consulting.project.text'
  | 'services.ai.search.title'
  | 'services.ai.search.text'
  | 'services.development.custom.title'
  | 'services.development.custom.text'
  | 'services.training.tech.title'
  | 'services.training.tech.text'
  // Services - Consulting
  | 'services.consulting.proposals.title'
  | 'services.consulting.proposals.text'
  | 'services.consulting.successfulProjects.title'
  | 'services.consulting.successfulProjects.text'
  | 'services.consulting.failedProjects.title'
  | 'services.consulting.failedProjects.text'
  // Services - AI Platform
  | 'services.aiPlatform.title'
  | 'services.aiPlatform.smartSearch.title'
  | 'services.aiPlatform.smartSearch.text'
  | 'services.aiPlatform.managementDashboards.title'
  | 'services.aiPlatform.managementDashboards.text'
  | 'services.aiPlatform.budgetsAndTime.title'
  | 'services.aiPlatform.budgetsAndTime.text'
  | 'services.aiPlatform.humanResources.title'
  | 'services.aiPlatform.humanResources.text'
  // Services - Development
  | 'services.development.customProgramming.title'
  | 'services.development.customProgramming.text'
  | 'services.development.mobileApps.title'
  | 'services.development.mobileApps.text'
  | 'services.development.webPlatforms.title'
  | 'services.development.webPlatforms.text'
  | 'services.development.thirdPartySolutions.title'
  | 'services.development.thirdPartySolutions.text'
  // Services - Training
  | 'services.training.newTechnologies.title'
  | 'services.training.newTechnologies.text'
  | 'services.training.informationTechnologies.title'
  | 'services.training.informationTechnologies.text'
  | 'services.training.newProcesses.title'
  | 'services.training.newProcesses.text'
  | 'services.training.createdPlatforms.title'
  | 'services.training.createdPlatforms.text'
  // Industries
  | 'industries.title'
  | 'industries.subtitle'
  | 'industries.government.title'
  | 'industries.government.text'
  | 'industries.industry.title'
  | 'industries.industry.text'
  | 'industries.health.title'
  | 'industries.health.text'
  | 'industries.retail.title'
  | 'industries.retail.text'
  | 'industries.startups.title'
  | 'industries.startups.text'
  // About Section
  | 'about.title'
  | 'about.subtitle'
  | 'about.history.title'
  | 'about.history.text'
  | 'about.mission.title'
  | 'about.mission.text'
  | 'about.vision.title'
  | 'about.vision.text'
  | 'about.team.title'
  | 'about.purpose.title'
  // new keys for about section
  | 'about.trayectory.title'
  | 'about.trayectory.n1'
  | 'about.trayectory.n2'
  | 'about.trayectory.n3'
  | 'about.trayectory.n4'
  | 'about.trayectory.years'
  | 'about.trayectory.projects'
  | 'about.trayectory.industries'
  | 'about.trayectory.solutions'
  // About - Growth & Challenges (NEW)
  | 'about.challenges.title'
  | 'about.challenges.title.part1'
  | 'about.challenges.title.part2'
  | 'about.challenges.subtitle'
  | 'about.challenges.step1.title'
  | 'about.challenges.step1.description'
  | 'about.challenges.step2.title'
  | 'about.challenges.step2.description'
  | 'about.challenges.step3.title'
  | 'about.challenges.step3.description'
  | 'about.challenges.step4.title'
  | 'about.challenges.step4.description'
  | 'about.solutions.title'
  | 'about.solutions.strategy.title'
  | 'about.solutions.strategy.description'
  | 'about.solutions.development.title'
  | 'about.solutions.development.description'
  | 'about.solutions.automation.title'
  | 'about.solutions.automation.description'
  | 'about.solutions.training.title'
  | 'about.solutions.training.description'
  | 'about.growth.title'
  | 'about.growth.step1.title'
  | 'about.growth.step1.description'
  | 'about.growth.step2.title'
  | 'about.growth.step2.description'
  | 'about.growth.step3.title'
  | 'about.growth.step3.description'
  // Common Challenges Section
  | 'challenges.title'
  | 'challenges.subtitle'
  | 'challenges.problem1'
  | 'challenges.problem2'
  | 'challenges.problem3'
  | 'challenges.problem4'
  | 'challenges.problem5'
  | 'challenges.footer'
  // Community Section
  | 'community.title'
  | 'community.subtitle'
  | 'community.blog.title'
  | 'community.podcast.title'
  | 'community.newsletter.title'
  // Contact Section
  | 'contact.title'
  | 'contact.social.title'
  | 'contact.form.name'
  | 'contact.form.subject'
  | 'contact.form.email'
  | 'contact.form.message'
  | 'contact.form.send'
  | 'contact.form.success'
  | 'contact.form.error'
  | 'contact.form.validation.required'
  | 'contact.form.validation.email'
  // Contact Form Labels
  | 'contact.form.labels.nombre'
  | 'contact.form.labels.asunto'
  | 'contact.form.labels.email'
  | 'contact.form.labels.mensaje'
  | 'contact.form.submit'
  // Footer
  | 'footer.rights'
  | 'footer.address'
  | 'footer.email'
  | 'footer.phone'
  // About Team Roles
  | 'about.team.roles.ceo'
  | 'about.team.roles.management'
  | 'about.team.roles.admin'
  | 'about.team.roles.marketing'
  | 'about.team.roles.sales'
  | 'about.team.roles.design'
  | 'about.team.roles.projectManager'
  | 'about.team.roles.seniorDev'
  | 'about.team.roles.fullstackDev'
  | 'footer.nav.home'
  | 'footer.nav.about'
  | 'footer.nav.industries'
  | 'footer.nav.services'
  | 'footer.nav.clients'
  | 'footer.nav.contact'
  | 'clients.title'
  | 'clients.title.part1'
  | 'clients.title.part2'
  // Services - New Sections (Process & Solutions)
  | 'services.section.intro.subtitle'
  | 'services.section.intro.description'
  | 'services.process.title'
  | 'services.process.title.part1'
  | 'services.process.title.part2'
  | 'services.process.step1.title'
  | 'services.process.step1.description'
  | 'services.process.step2.title'
  | 'services.process.step2.description'
  | 'services.process.step3.title'
  | 'services.process.step3.description'
  | 'services.solutions.title'
  | 'services.solutions.software.title'
  | 'services.solutions.software.features'
  | 'services.solutions.iot.title'
  | 'services.solutions.iot.features'
  | 'services.solutions.ai.title'
  | 'services.solutions.ai.features'
  | 'services.solutions.web.title'
  | 'services.solutions.web.features'
  | 'services.solutions.training.title'
  | 'services.solutions.training.features'
  | 'services.solutions.elearning.title'
  | 'services.solutions.elearning.features';

// Define the structure of translations
type TranslationsType = {
  [K in Language]: {
    [K in TranslationKey]: string;
  };
};

const translations: TranslationsType = {
  es: {
    // Banner & Home
    'nav.home': 'INICIO',
    'nav.about': 'NOSOTROS',
    'nav.industries': 'INDUSTRIAS',
    'nav.services': 'SERVICIOS',
    'nav.clients': 'CLIENTES',
    'nav.contact': 'CONTACTO',
    'banner.title': 'Tu negocio crece.',
    'banner.title2': 'Nosotros te acompañamos.',
    'banner.subtitle': 'Acompañamos el crecimiento de tu negocio con tecnología, estrategia y soluciones a medida.',
    'banner.schedule': 'Descubrí lo que hacemos →',
    
    // Home Cards
    'home.consulting.title': 'CONSULTORÍA',
    'home.consulting.text': 'Te acompañamos en procesos de innovación, exploración del metaverso, incorporación de inteligencia artificial y estrategias de transformación para tu negocio.',
    'home.development.title': 'DESARROLLO',
    'home.development.text': 'Creamos software a medida, sitios web, aplicaciones y soluciones tecnológicas alineadas con tus objetivos de negocio.',
    'home.training.title': 'CAPACITACIÓN',
    'home.training.text': 'Formación integral en las últimas tendencias tecnológicas para desarrollar competencias digitales y aumentar la competitividad en un mundo cada vez más digitalizado.',

    // Services
    'services.title': 'SERVICIOS',
    'services.consulting.title': 'Consultoría',
    'services.ai.title': 'Plataforma IA',
    'services.development.title': 'Desarrollo',
    'services.training.title': 'Capacitaciones',
    
    'services.consulting.project.title': 'Viabilidad de proyectos',
    'services.consulting.project.text': 'Evaluamos técnica y estratégicamente si tu idea puede convertirse en un proyecto exitoso, sostenible y escalable.',

    'services.ai.search.title': 'Búsqueda inteligente',
    'services.ai.search.text': 'Desarrollamos asistentes con IA que consultan bases de conocimiento internas para encontrar información clave en segundos.',

    'services.development.custom.title': 'Programación a medida',
    'services.development.custom.text': 'Creamos soluciones únicas adaptadas a las necesidades específicas de cada cliente, con tecnología robusta y escalable.',

    'services.training.tech.title': 'Nuevas tecnologías',
    'services.training.tech.text': 'Capacitamos en IA, blockchain, metaverso y más, con foco en aplicación real para empresas e instituciones.',

    // Services - Consulting
    'services.consulting.proposals.title': 'Propuestas realizadas',
    'services.consulting.proposals.text': 'Desarrollamos propuestas innovadoras adaptadas a cada cliente, integrando tecnología y visión de futuro.',
    'services.consulting.successfulProjects.title': 'Proyectos exitosos',
    'services.consulting.successfulProjects.text': 'Implementamos soluciones tecnológicas que transformaron procesos y generaron impacto real en múltiples industrias.',
    'services.consulting.failedProjects.title': 'Proyectos fracasados',
    'services.consulting.failedProjects.text': 'Analizamos errores de implementación o contexto para aprender, mejorar procesos y evitar futuros riesgos tecnológicos.',

    // Services - AI Platform
    'services.aiPlatform.title': 'Plataforma IA',
    'services.aiPlatform.smartSearch.title': 'Búsqueda Inteligente',
    'services.aiPlatform.smartSearch.text': 'Asistentes que consultan bases de conocimiento internas para encontrar información clave en segundos.',
    'services.aiPlatform.managementDashboards.title': 'Dashboards de Gestión',
    'services.aiPlatform.managementDashboards.text': 'Visualiza y gestiona indicadores clave de rendimiento en tiempo real.',
    'services.aiPlatform.budgetsAndTime.title': 'Presupuestos y Tiempos',
    'services.aiPlatform.budgetsAndTime.text': 'Estimaciones precisas de costos y plazos para la implementación de proyectos.',
    'services.aiPlatform.humanResources.title': 'Recursos Humanos',
    'services.aiPlatform.humanResources.text': 'Optimización de la gestión del talento y análisis de desempeño.',

    // Services - Development
    'services.development.customProgramming.title': 'Programación a medida',
    'services.development.customProgramming.text': 'Soluciones únicas adaptadas a las necesidades específicas de cada cliente.',
    'services.development.mobileApps.title': 'Aplicaciones móviles',
    'services.development.mobileApps.text': 'Desarrollo de aplicaciones para iOS y Android, optimizadas para rendimiento y experiencia de usuario.',
    'services.development.webPlatforms.title': 'Plataformas web',
    'services.development.webPlatforms.text': 'Creación de sitios web y aplicaciones web escalables y seguras.',
    'services.development.thirdPartySolutions.title': 'Soluciones de terceros',
    'services.development.thirdPartySolutions.text': 'Integración de herramientas y plataformas externas para ampliar funcionalidades.',

    // Services - Training
    'services.training.newTechnologies.title': 'Nuevas tecnologías',
    'services.training.newTechnologies.text': 'Capacitación en las últimas tendencias tecnológicas.',
    'services.training.informationTechnologies.title': 'Tecnologías de la información',
    'services.training.informationTechnologies.text': 'Formación en gestión y estrategia de TI.',
    'services.training.newProcesses.title': 'Nuevos procesos',
    'services.training.newProcesses.text': 'Capacitación en metodologías ágiles y optimización de procesos.',
    'services.training.createdPlatforms.title': 'Plataformas creadas',
    'services.training.createdPlatforms.text': 'Entrenamiento en el uso y gestión de plataformas tecnológicas implementadas.',

    // Services - Process & Solutions (NEW)
    'services.section.intro.subtitle': 'Sección de servicios que hacemos',
    'services.section.intro.description': 'Te acompañamos de punta a punta…',
    'services.process.title': 'Te acompañamos de punta a punta…',
    'services.process.title.part1': 'Te acompañamos de',
    'services.process.title.part2': 'punta a punta…',
    'services.process.step1.title': 'Diagnóstico estratégico',
    'services.process.step1.description': 'Analizamos tu operación, procesos y objetivos para entender dónde está el verdadero problema.',
    'services.process.step2.title': 'Diseño de la solución',
    'services.process.step2.description': 'Definimos la mejor combinación de tecnología, estrategia y procesos según impacto y viabilidad.',
    'services.process.step3.title': 'Implementación y acompañamiento',
    'services.process.step3.description': 'Desarrollamos, integramos y evolucionamos la solución junto a tu equipo.',
    'services.solutions.title': 'Soluciones pensadas para tu negocio',
    'services.solutions.software.title': 'Desarrollo de software a medida',
    'services.solutions.software.features': 'Sistemas web, apps móviles, plataformas cloud|Backend en Node/Java/Python|Integraciones con ERP, CRM, sensores, hardware|APIs y microservicios',
    'services.solutions.iot.title': 'IoT, sensorización y automatización',
    'services.solutions.iot.features': 'Sensores industriales|Integración con máquinas chinas (Modbus/PLC)|Tableros de control en tiempo real|Mantenimiento predictivo con IA',
    'services.solutions.ai.title': 'Inteligencia Artificial aplicada',
    'services.solutions.ai.features': 'Chatbots para WhatsApp y web|IA para atención telefónica|IA para validación de calidad por imágenes|Sistemas predictivos',
    'services.solutions.web.title': 'Desarrollo Web, Branding y Marketing Digital',
    'services.solutions.web.features': 'Diseño UX/UI|Web corporativa|Ecommerce|Sistemas de reservas|Estrategia digital + performance|Redes sociales',
    'services.solutions.training.title': 'Capacitación & Transformación Cultura',
    'services.solutions.training.features': 'Programas de formación ejecutiva|Talleres a medida para empresas|Capacitación en IA, transformación digital, data y estrategia',
    'services.solutions.elearning.title': 'Contenidos interactivos & e-learning',
    'services.solutions.elearning.features': 'Cursos gamificados|Guías dinámicas|Videos instructivos y tutoriales|Capacitación interna con personajes 2D/3D',

    // Industries
    'industries.title': 'INDUSTRIAS',
    'industries.subtitle': 'Soluciones tecnológicas especializadas para cada sector, impulsando la innovación y el crecimiento.',
    'industries.government.title': 'GOBIERNO',
    'industries.government.text': 'Soluciones para modernizar servicios públicos y mejorar la eficiencia administrativa.',
    'industries.industry.title': 'INDUSTRIA',
    'industries.industry.text': 'Optimización de procesos y sistemas inteligentes para la manufactura moderna.',
    'industries.health.title': 'SALUD',
    'industries.health.text': 'Plataformas digitales para mejorar la atención médica y gestión hospitalaria.',
    'industries.retail.title': 'RETAIL',
    'industries.retail.text': 'Soluciones omnicanal para potenciar ventas y experiencia del cliente.',
    'industries.startups.title': 'PYMES Y STARTUPS',
    'industries.startups.text': 'Herramientas tecnológicas para impulsar el crecimiento empresarial.',

    // About Section
    'about.title': 'NOSOTROS',
    'about.subtitle': 'Enfocados en impulsar la transformación digital de empresas a través de soluciones personalizadas, innovación y acompañamiento constante.',
    'about.history.title': 'NUESTRA HISTORIA',
    'about.history.text': 'En Lucods, brindamos soluciones tecnológicas diseñadas a medida según los objetivos de cada cliente. Desde 2019, acompañamos a empresas y profesionales en su transformación digital.',
    'about.trayectory.n1': 'Años de experiencia',
    'about.trayectory.n2': 'Proyectos implementados',
    'about.trayectory.n3': 'Industrias en las que trabajamos',
    'about.trayectory.n4': 'Soluciones a medida',
    'about.trayectory.years': 'Años de experiencia',
    'about.trayectory.projects': 'Proyectos implementados',
    'about.trayectory.industries': 'Industrias en las que trabajamos',
    'about.trayectory.solutions': 'Soluciones a medida',
    'about.mission.title': 'Misión',
    'about.mission.text': 'Nuestra misión es ofrecer servicios tecnológicos innovadores y eficientes que potencien el crecimiento de tu negocio.',
    'about.vision.title': 'Visión',
    'about.vision.text': 'Ser referente global en la integración de tecnologías avanzadas, liderando la transformación digital.',
    'about.purpose.title': 'PROPÓSITO Y VISIÓN',
    'about.trayectory.title': 'NUESTRA TRAYECTORIA',
    'about.team.title': 'EQUIPO',
    'about.team.roles.ceo': 'CEO & Fundador',
    'about.team.roles.management': 'Control de Gestión',
    'about.team.roles.admin': 'Administración',
    'about.team.roles.marketing': 'Marketing Digital',
    'about.team.roles.sales': 'Ventas',
    'about.team.roles.design': 'Diseño Gráfico',
    'about.team.roles.projectManager': 'Project Manager',
    'about.team.roles.seniorDev': 'Desarrollador Senior',
    'about.team.roles.fullstackDev': 'Desarrollador Fullstack',

    // About - Growth Challenges (NEW)
    'about.challenges.title': 'Así empieza a desordenarse un negocio que crece',
    'about.challenges.title.part1': 'Así empieza a desordenarse un negocio',
    'about.challenges.title.part2': 'que crece',
    'about.challenges.subtitle': '',
    'about.challenges.step1.title': 'Crece',
    'about.challenges.step1.description': 'Todo funciona. El negocio crece, el equipo se adapta y los resultados acompañan.',
    'about.challenges.step2.title': 'Sumás herramientas',
    'about.challenges.step2.description': 'Empieza el desorden. Cada área usa lo que necesita. Empiezan a aparecer herramientas aisladas y datos dispersos.',
    'about.challenges.step3.title': 'Aumenta la operación',
    'about.challenges.step3.description': 'Aparecen los problemas. Más tareas manuales, más entre y menos visibilidad sobre lo importante.',
    'about.challenges.step4.title': 'Pierdes control',
    'about.challenges.step4.description': 'Todo se vuelve caótico. Decisiones lentas, información poco confiable y crecimiento desorganizado.',
    // About - Solutions (NEW)
    'about.solutions.title': 'Soluciones que se adaptan a tu negocio, no al revés.',
    'about.solutions.strategy.title': 'Estrategia & Consultoría',
    'about.solutions.strategy.description': 'Definimos el camino tecnológico y de negocio para tomar mejores decisiones y crecer con claridad.',
    'about.solutions.development.title': 'Desarrollo a medida',
    'about.solutions.development.description': 'Creamos software alineado a tus procesos reales para resolver lo que tu operación necesita.',
    'about.solutions.automation.title': 'Automatización & IA',
    'about.solutions.automation.description': 'Optimizamos procesos y automatizamos tareas para mejorar eficiencia y escalar tu operación.',
    'about.solutions.training.title': 'Capacitación & adopción',
    'about.solutions.training.description': 'Acompañamos a tu equipo para que la tecnología genere impacto real en el negocio.',
    // About - Growth Accompaniment (NEW)
    'about.growth.title': 'Cómo acompañamos tu crecimiento de punta a punta',
    'about.growth.step1.title': 'Diagnóstico estratégico',
    'about.growth.step1.description': 'Analizamos tu operación, procesos y objetivos para entender dónde está el verdadero problema.',
    'about.growth.step2.title': 'Diseño de la solución',
    'about.growth.step2.description': 'Definimos tecnología, estrategia y procesos según impacto y viabilidad.',
    'about.growth.step3.title': 'Implementación y acompañamiento',
    'about.growth.step3.description': 'Desarrollamos e implementamos la solución y acompañamos la adopción junto a tu equipo.',

    // Common Challenges
    'challenges.title': 'NO SOS EL ÚNICO',
    'challenges.subtitle': 'Todos los negocios que crecen pasan por esto',
    'challenges.problem1': 'Procesos que no escalan',
    'challenges.problem2': 'Sistemas desconectados',
    'challenges.problem3': 'Falta de automatización en tareas clave',
    'challenges.problem4': 'Falta de estrategia de marketing',
    'challenges.problem5': 'Decisiones basadas en intuición en lugar de datos',
    'challenges.footer': 'Cuando la tecnología no acompaña, el crecimiento se vuelve frágil.',

    // Community Section
    'community.title': 'COMUNIDAD',
    'community.subtitle': 'Conectamos personas y conocimiento para crear un ecosistema tecnológico más fuerte.',
    'community.blog.title': 'BLOG',
    'community.podcast.title': 'PODCAST',
    'community.newsletter.title': 'NEWSLETTER',

    // Contact Section
    'contact.title': 'CONTACTO',
    'contact.social.title': 'REDES',
    'contact.form.name': 'NOMBRE',
    'contact.form.subject': 'ASUNTO',
    'contact.form.email': 'EMAIL',
    'contact.form.message': 'MENSAJE',
    'contact.form.send': 'ENVIAR',
    'contact.form.success': '¡Mensaje enviado correctamente!',
    'contact.form.error': 'Ocurrió un error al enviar el mensaje. Intenta nuevamente.',
    'contact.form.validation.required': 'Este campo es obligatorio.',
    'contact.form.validation.email': 'El email no es válido.',
    // Contact Form Labels
    'contact.form.labels.nombre': 'NOMBRE',
    'contact.form.labels.asunto': 'ASUNTO',
    'contact.form.labels.email': 'EMAIL',
    'contact.form.labels.mensaje': 'MENSAJE',
    'contact.form.submit': 'ENVIAR',
    // Footer
    'footer.rights': '© Copyright 2025 Lucods, Todos los derechos reservados.',
    'footer.address': 'Terrada 1971, Buenos Aires, Argentina',
    'footer.email': 'info@lucods.com / ventas@lucods.com',
    'footer.phone': 'Tel: 11-5491-6006',
    'footer.nav.home': 'INICIO',
    'footer.nav.about': 'NOSOTROS',
    'footer.nav.industries': 'INDUSTRIAS',
    'footer.nav.services': 'SERVICIOS',
    'footer.nav.clients': 'CLIENTES',
    'footer.nav.contact': 'CONTACTO',
    'clients.title': 'Trabajamos con empresas donde la tecnología impacta en la operación',
    'clients.title.part1': 'Trabajamos con empresas donde la tecnología',
    'clients.title.part2': 'impacta en la operación',
  },
  en: {
    // Banner & Home
    'nav.home': 'HOME',
    'nav.about': 'ABOUT',
    'nav.industries': 'INDUSTRIES',
    'nav.services': 'SERVICES',
    'nav.clients': 'CLIENTS',
    'nav.contact': 'CONTACT',
    'banner.title': 'Your business grows.',
    'banner.title2': 'We accompany you.',
    'banner.subtitle': 'We accompany the growth of your business with technology, strategy and tailor-made solutions.',
    'banner.schedule': 'Discover what we do →',
    
    // Home Cards
    'home.consulting.title': 'CONSULTING',
    'home.consulting.text': 'We accompany you in innovation processes, metaverse exploration, artificial intelligence incorporation, and transformation strategies for your business.',
    'home.development.title': 'DEVELOPMENT',
    'home.development.text': 'We create custom software, websites, applications, and technological solutions aligned with your business objectives.',
    'home.training.title': 'TRAINING',
    'home.training.text': 'Comprehensive training in the latest technological trends to develop digital skills and increase competitiveness in an increasingly digitalized world.',

    // Services
    'services.title': 'SERVICES',
    'services.consulting.title': 'Consulting',
    'services.ai.title': 'AI Platform',
    'services.development.title': 'Development',
    'services.training.title': 'Training',
    
    'services.consulting.project.title': 'Project Viability',
    'services.consulting.project.text': 'We technically and strategically evaluate if your idea can become a successful, sustainable, and scalable project.',

    'services.ai.search.title': 'Intelligent Search',
    'services.ai.search.text': 'We develop AI assistants that query internal knowledge bases to find key information in seconds.',

    'services.development.custom.title': 'Custom Programming',
    'services.development.custom.text': 'We create unique solutions tailored to each client\'s specific needs, with robust and scalable technology.',

    'services.training.tech.title': 'New Technologies',
    'services.training.tech.text': 'We train in AI, blockchain, metaverse, and more, focusing on real application for companies and institutions.',

    // Services - Consulting
    'services.consulting.proposals.title': 'Completed Proposals',
    'services.consulting.proposals.text': 'We develop innovative proposals tailored to each client, integrating technology and future vision.',
    'services.consulting.successfulProjects.title': 'Successful Projects',
    'services.consulting.successfulProjects.text': 'We implement technological solutions that transformed processes and generated real impact across multiple industries.',
    'services.consulting.failedProjects.title': 'Failed Projects',
    'services.consulting.failedProjects.text': 'We analyze implementation or context errors to learn, improve processes and avoid future technological risks.',

    // Services - AI Platform
    'services.aiPlatform.title': 'AI Platform',
    'services.aiPlatform.smartSearch.title': 'Intelligent Search',
    'services.aiPlatform.smartSearch.text': 'Assistants that query internal knowledge bases to find key information in seconds.',
    'services.aiPlatform.managementDashboards.title': 'Management Dashboards',
    'services.aiPlatform.managementDashboards.text': 'View and manage key performance indicators in real time.',
    'services.aiPlatform.budgetsAndTime.title': 'Budgets and Time',
    'services.aiPlatform.budgetsAndTime.text': 'Accurate cost and timeline estimates for project implementation.',
    'services.aiPlatform.humanResources.title': 'Human Resources',
    'services.aiPlatform.humanResources.text': 'Optimization of talent management and performance analysis.',

    // Services - Development
    'services.development.customProgramming.title': 'Custom Programming',
    'services.development.customProgramming.text': 'Unique solutions tailored to each client\'s specific needs.',
    'services.development.mobileApps.title': 'Mobile Apps',
    'services.development.mobileApps.text': 'Development of iOS and Android applications, optimized for performance and user experience.',
    'services.development.webPlatforms.title': 'Web Platforms',
    'services.development.webPlatforms.text': 'Creation of scalable and secure websites and web applications.',
    'services.development.thirdPartySolutions.title': 'Third Party Solutions',
    'services.development.thirdPartySolutions.text': 'Integration of external tools and platforms to expand functionalities.',

    // Services - Training
    'services.training.newTechnologies.title': 'New Technologies',
    'services.training.newTechnologies.text': 'Training in the latest technological trends.',
    'services.training.informationTechnologies.title': 'Information Technologies',
    'services.training.informationTechnologies.text': 'Training in IT management and strategy.',
    'services.training.newProcesses.title': 'New Processes',
    'services.training.newProcesses.text': 'Training in agile methodologies and process optimization.',
    'services.training.createdPlatforms.title': 'Created Platforms',
    'services.training.createdPlatforms.text': 'Training in the use and management of implemented technological platforms.',

    // Services - Process & Solutions (NEW)
    'services.section.intro.subtitle': 'Services section we provide',
    'services.section.intro.description': 'We accompany you from start to finish…',
    'services.process.title': 'We accompany you from start to finish…',
    'services.process.title.part1': 'We accompany you from',
    'services.process.title.part2': 'start to finish…',
    'services.process.step1.title': 'Strategic Diagnosis',
    'services.process.step1.description': 'We analyze processes, operations and real business objectives.',
    'services.process.step2.title': 'Solution Design',
    'services.process.step2.description': 'We define the right technology based on impact and feasibility.',
    'services.process.step3.title': 'Implementation & Support',
    'services.process.step3.description': 'We develop, integrate and support your growth.',
    'services.solutions.title': 'Solutions designed for your business',
    'services.solutions.software.title': 'Custom software development',
    'services.solutions.software.features': 'Web systems, mobile apps, cloud platforms|Backend in Node/Java/Python|Integrations with ERP, CRM, sensors, hardware|APIs and microservices',
    'services.solutions.iot.title': 'IoT, sensing and automation',
    'services.solutions.iot.features': 'Industrial sensors|Integration with Chinese machines (Modbus/PLC)|Real-time control dashboards|Predictive maintenance with AI',
    'services.solutions.ai.title': 'Applied Artificial Intelligence',
    'services.solutions.ai.features': 'Chatbots for WhatsApp and web|AI for phone support|AI for quality validation by images|Predictive systems',
    'services.solutions.web.title': 'Web Development, Branding and Digital Marketing',
    'services.solutions.web.features': 'UX/UI Design|Corporate website|E-commerce|Reservation systems|Digital strategy + performance|Social media',
    'services.solutions.training.title': 'Training & Cultural Transformation',
    'services.solutions.training.features': 'Executive training programs|Custom workshops for companies|Training in AI, digital transformation, data and strategy',
    'services.solutions.elearning.title': 'Interactive content & e-learning',
    'services.solutions.elearning.features': 'Gamified courses|Dynamic guides|Instructional videos and tutorials|Internal training with 2D/3D characters',

    // Industries
    'industries.title': 'INDUSTRIES',
    'industries.subtitle': 'Specialized technological solutions for each sector, driving innovation and growth.',
    'industries.government.title': 'GOVERNMENT',
    'industries.government.text': 'Solutions to modernize public services and improve administrative efficiency.',
    'industries.industry.title': 'INDUSTRY',
    'industries.industry.text': 'Process optimization and intelligent systems for modern manufacturing.',
    'industries.health.title': 'HEALTHCARE',
    'industries.health.text': 'Digital platforms to improve healthcare and hospital management.',
    'industries.retail.title': 'RETAIL',
    'industries.retail.text': 'Omnichannel solutions to boost sales and customer experience.',
    'industries.startups.title': 'SMEs & STARTUPS',
    'industries.startups.text': 'Technological tools to drive business growth.',

    // About Section
    'about.title': 'ABOUT US',
    'about.subtitle': 'Focused on driving business digital transformation through customized solutions, innovation and constant support.',
    'about.history.title': 'OUR HISTORY',
    'about.history.text': 'At Lucods, we provide customized technological solutions based on each client\'s objectives. Since 2019, we\'ve been supporting companies and professionals in their digital transformation.',
    'about.trayectory.n1': 'Years of experience',
    'about.trayectory.n2': 'Implemented projects',
    'about.trayectory.n3': 'Industries we work with',
    'about.trayectory.n4': 'Tailored solutions',
    'about.trayectory.years': 'Years of experience',
    'about.trayectory.projects': 'Implemented projects',
    'about.trayectory.industries': 'Industries we work with',
    'about.trayectory.solutions': 'Tailored solutions',
    'about.mission.title': 'Mission',
    'about.mission.text': 'Our mission is to provide innovative and efficient technological services that enhance your business growth.',
    'about.vision.title': 'Vision',
    'about.vision.text': 'To be a global reference in advanced technology integration, leading digital transformation.',
    'about.purpose.title': 'PURPOSE AND VISION',
    'about.trayectory.title': 'OUR TRAJECTORY',
    'about.team.title': 'TEAM',
    'about.team.roles.ceo': 'CEO & Founder',
    'about.team.roles.management': 'Management Control',
    'about.team.roles.admin': 'Administration',
    'about.team.roles.marketing': 'Digital Marketing',
    'about.team.roles.sales': 'Sales',
    'about.team.roles.design': 'Graphic Design',
    'about.team.roles.projectManager': 'Project Manager',
    'about.team.roles.seniorDev': 'Senior Developer',
    'about.team.roles.fullstackDev': 'Fullstack Developer',

    // About - Growth Challenges (NEW)
    'about.challenges.title': 'How a growing business starts to get chaotic',
    'about.challenges.title.part1': 'How a growing business starts to get',
    'about.challenges.title.part2': 'chaotic',
    'about.challenges.subtitle': '',
    'about.challenges.step1.title': 'It grows',
    'about.challenges.step1.description': 'Everything works. The business grows and the team adapts, results follow.',
    'about.challenges.step2.title': 'You add tools',
    'about.challenges.step2.description': 'Chaos begins. Each area uses what they need.',
    'about.challenges.step3.title': 'Operations increase',
    'about.challenges.step3.description': 'Problems appear. More manual tasks, more handoffs, less visibility on what matters.',
    'about.challenges.step4.title': 'You lose control',
    'about.challenges.step4.description': 'Everything becomes chaotic. Slow decisions, unreliable information and disorganized tracking.',
    // About - Solutions (NEW)
    'about.solutions.title': 'Solutions that adapt to your business, not the other way around.',
    'about.solutions.strategy.title': 'Strategy & Consulting',
    'about.solutions.strategy.description': 'We define the technological and business path to make better decisions and grow with clarity.',
    'about.solutions.development.title': 'Custom Development',
    'about.solutions.development.description': 'We create software aligned to your real processes to solve what your operation needs.',
    'about.solutions.automation.title': 'Automation & AI',
    'about.solutions.automation.description': 'We optimize processes and automate tasks to improve efficiency and scale your operation.',
    'about.solutions.training.title': 'Training & Adoption',
    'about.solutions.training.description': 'We support your team so that technology generates real impact on your business.',
    // About - Growth Accompaniment (NEW)
    'about.growth.title': 'How we support your growth from start to finish',
    'about.growth.step1.title': 'Strategic Diagnosis',
    'about.growth.step1.description': 'We analyze operations, processes and goals to understand the real problem.',
    'about.growth.step2.title': 'Solution Design',
    'about.growth.step2.description': 'We define technology, strategy and processes based on impact and feasibility.',
    'about.growth.step3.title': 'Implementation & Support',
    'about.growth.step3.description': 'We develop and implement the solution and support adoption with your team.',

    // Common Challenges
    'challenges.title': 'YOU\'RE NOT ALONE',
    'challenges.subtitle': 'All growing businesses go through this',
    'challenges.problem1': 'Processes that don\'t scale',
    'challenges.problem2': 'Disconnected systems',
    'challenges.problem3': 'Lack of automation in key tasks',
    'challenges.problem4': 'Lack of marketing strategy',
    'challenges.problem5': 'Decisions based on intuition instead of data',
    'challenges.footer': 'When technology doesn\'t support you, growth becomes fragile.',

    // Community Section
    'community.title': 'COMMUNITY',
    'community.subtitle': 'Connecting people and knowledge to create a stronger technological ecosystem.',
    'community.blog.title': 'BLOG',
    'community.podcast.title': 'PODCAST',
    'community.newsletter.title': 'NEWSLETTER',

    // Contact Section
    'contact.title': 'CONTACT',
    'contact.social.title': 'SOCIAL',
    'contact.form.name': 'NAME',
    'contact.form.subject': 'SUBJECT',
    'contact.form.email': 'EMAIL',
    'contact.form.message': 'MESSAGE',
    'contact.form.send': 'SEND',
    'contact.form.success': 'Message sent successfully!',
    'contact.form.error': 'An error occurred while sending the message. Please try again.',
    'contact.form.validation.required': 'This field is required.',
    'contact.form.validation.email': 'Invalid email address.',
    // Contact Form Labels
    'contact.form.labels.nombre': 'NAME',
    'contact.form.labels.asunto': 'SUBJECT',
    'contact.form.labels.email': 'EMAIL',
    'contact.form.labels.mensaje': 'MESSAGE',
    'contact.form.submit': 'SEND',
    // Footer
    'footer.rights': '© Copyright 2025 Lucods, All rights reserved.',
    'footer.address': 'Terrada 1971, Buenos Aires, Argentina',
    'footer.email': 'info@lucods.com / sales@lucods.com',
    'footer.phone': 'Phone: 11-5491-6006',
    'footer.nav.home': 'HOME',
    'footer.nav.about': 'ABOUT',
    'footer.nav.industries': 'INDUSTRIES',
    'footer.nav.services': 'SERVICES',
    'footer.nav.clients': 'CLIENTS',
    'footer.nav.contact': 'CONTACT',
    'clients.title': 'OUR CLIENTS',
    'clients.title.part1': 'We work with companies where technology',
    'clients.title.part2': 'impacts operations',
  }
};

interface LanguageContextType {
  language: Language;
  toggleLanguage: () => void;
  t: (key: TranslationKey) => string;  // Update the type here
}

const LanguageContext = createContext<LanguageContextType | null>(null);

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [language, setLanguage] = useState<Language>('es');

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'es' ? 'en' : 'es');
  };

  const t = (key: TranslationKey): string => {
    return translations[language][key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
